import { ComponentPropsWithRef } from "react";

/**
 * Basic plus (+) icon rendered as an inline SVG.
 *
 * This is a bare-bones icon — it contains only the plus shape itself, with no
 * additional elements. Its size can be adjusted by overriding
 * the `width` and `height` props (defaults are 16×16).
 *
 */
export const PlusIcon = ({ ref, ...props }: ComponentPropsWithRef<"svg">) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    ref={ref}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 6.2689V9.7311C16 10.0508 15.7415 10.3081 15.423 10.3081H10.3081V15.423C10.3081 15.7426 10.0496 16 9.7311 16H6.2689C5.95038 16 5.69186 15.7426 5.69186 15.423V10.3081H0.577034C0.258511 10.3081 0 10.0508 0 9.7311V6.2689C0 5.95038 0.258511 5.69187 0.577034 5.69187H5.69186V0.577034C5.69186 0.258511 5.95038 0 6.2689 0H9.7311C10.0496 0 10.3081 0.258511 10.3081 0.577034V5.69187H15.423C15.7415 5.69187 16 5.95038 16 6.2689Z"
      fill="currentColor"
    />
  </svg>
);
